import { lazy } from "react";

const pageRegistry = {
  "dashboard:index": lazy(() => import("../pages/DashboardPage")),
  "users:index": lazy(() => import("../pages/users/UsersModulePage")),
  "users:list": lazy(() => import("../pages/users/UsersModulePage")),
  "users:create": lazy(() => import("../pages/users/UsersModulePage")),
  "users:edit": lazy(() => import("../pages/users/UsersModulePage")),
  "users:update": lazy(() => import("../pages/users/UsersModulePage")),
  "user:index": lazy(() => import("../pages/users/UsersModulePage")),
  "user-master:user": lazy(() => import("../pages/users/UsersModulePage")),
  "user-master:users": lazy(() => import("../pages/users/UsersModulePage")),
  "user-master:roles": lazy(() => import("../pages/roles/RolesModulePage")),
  "user-master:index": lazy(() => import("../pages/users/UsersModulePage")),
  "role": lazy(() => import("../pages/roles/RolesModulePage")),
  "role:index": lazy(() => import("../pages/roles/RolesModulePage")),
  "role:roles": lazy(() => import("../pages/roles/RolesModulePage")),
  "roles:index": lazy(() => import("../pages/roles/RolesModulePage")),
  "roles:list": lazy(() => import("../pages/roles/RolesModulePage")),
  "roles:read": lazy(() => import("../pages/roles/RolesModulePage")),
  "menu": lazy(() => import("../pages/menus/MenuListPage")),
  "menu:index": lazy(() => import("../pages/menus/MenuListPage")),
  "menu:menus": lazy(() => import("../pages/menus/MenuListPage")),
  "menus:index": lazy(() => import("../pages/menus/MenuListPage")),
  "country:index": lazy(() => import("../pages/country/CountryModulePage")),
  "country:list": lazy(() => import("../pages/country/CountryModulePage")),
  "country:create": lazy(() => import("../pages/country/CountryModulePage")),
  "country:edit": lazy(() => import("../pages/country/CountryModulePage")),
  "country:update": lazy(() => import("../pages/country/CountryModulePage")),
  "master:country": lazy(() => import("../pages/country/CountryModulePage")),
  "settings-master:country": lazy(() => import("../pages/country/CountryModulePage")),
  "payment-mode:index": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "payment-mode:list": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "payment-mode:create": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "payment-mode:edit": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "payment-mode:update": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "master:payment-mode": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "settings-master:payment-mode": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "payment-mode": lazy(() => import("../pages/paymentMode/PaymentModeModulePage")),
  "party:index": lazy(() => import("../pages/vendor/VendorModulePage")),
  "party:list": lazy(() => import("../pages/vendor/VendorModulePage")),
  "party:create": lazy(() => import("../pages/vendor/VendorModulePage")),
  "party:edit": lazy(() => import("../pages/vendor/VendorModulePage")),
  "party:update": lazy(() => import("../pages/vendor/VendorModulePage")),
  "master:party": lazy(() => import("../pages/vendor/VendorModulePage")),
  "settings-master:party": lazy(() => import("../pages/vendor/VendorModulePage")),
  "vendor:index": lazy(() => import("../pages/vendor/VendorModulePage")),
  "vendor:list": lazy(() => import("../pages/vendor/VendorModulePage")),
  "vendor:create": lazy(() => import("../pages/vendor/VendorModulePage")),
  "vendor:edit": lazy(() => import("../pages/vendor/VendorModulePage")),
  "vendor:update": lazy(() => import("../pages/vendor/VendorModulePage")),
  "master:vendor": lazy(() => import("../pages/vendor/VendorModulePage")),
  "settings-master:vendor": lazy(() => import("../pages/vendor/VendorModulePage")),
  "bl-master:index": lazy(() => import("../pages/bl/BLListPage")),
  "bl-master:list": lazy(() => import("../pages/bl/BLListPage")),
  "bl-master:read": lazy(() => import("../pages/bl/BLListPage")),
  "blmaster:index": lazy(() => import("../pages/bl/BLListPage")),
  "blmaster:list": lazy(() => import("../pages/bl/BLListPage")),
  "blmaster:read": lazy(() => import("../pages/bl/BLListPage")),
  "blmaster:bl-management": lazy(() => import("../pages/bl/BLListPage")),
  "bl-master:bl-details": lazy(() => import("../pages/bl/BLListPage")),
  "bl-management:bl-master": lazy(() => import("../pages/bl/BLListPage")),
  "bl-management:bl-details": lazy(() => import("../pages/bl/BLListPage")),
  "bl-details:index": lazy(() => import("../pages/bl/BLListPage")),
  "bl-master:create": lazy(() => import("../pages/bl/BLFormPage")),
  "bl-master:edit": lazy(() => import("../pages/bl/BLFormPage")),
  "bl-management:stock-processing": lazy(() => import("../pages/bl/StockProcessingPage")),
  "stock-processing:stock-processing": lazy(() => import("../pages/bl/StockProcessingPage")),
  "stock-transfer:index": lazy(() => import("../pages/bl/StockTransferListPage")),
  "stock-transfer:create": lazy(() => import("../pages/bl/StockTransferCreatePage")),
  "containers:index": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "containers:list": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "containers:create": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "containers:edit": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details:index": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details:list": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details:create": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details:edit": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "bl-container-stock-details:bl-container-stock-details": lazy(() => import("../pages/bl/BLContainerModulePage")),
  "stock-category:index": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "stock-category:list": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "stock-category:create": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "stock-category:edit": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "stock-category:update": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "master:stock-category": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "settings-master:stock-category": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "stock-category": lazy(() => import("../pages/stockCategory/StockCategoryModulePage")),
  "currency-uom": lazy(() => import("../pages/currencyUom/CurrencyUomModulePage")),
  "settings-master:currency-uom": lazy(() => import("../pages/currencyUom/CurrencyUomModulePage")),
  "settings-master:lot": lazy(() => import("../pages/lot/LotModulePage")),
  "lot:index": lazy(() => import("../pages/lot/LotModulePage")),
  "settings-master:yard": lazy(() => import("../pages/yard/YardModulePage")),
  "yard:index": lazy(() => import("../pages/yard/YardModulePage")),
  "yard:list": lazy(() => import("../pages/yard/YardModulePage")),
  "yard:create": lazy(() => import("../pages/yard/YardModulePage")),
  "yard:edit": lazy(() => import("../pages/yard/YardModulePage")),
  "yard:update": lazy(() => import("../pages/yard/YardModulePage")),
  "reports:container-wise": lazy(() => import("../pages/reports/ContainerWiseReportPage")),
  "reports:container-wise-report": lazy(() => import("../pages/reports/ContainerWiseReportPage")),
  "container-wise:index": lazy(() => import("../pages/reports/ContainerWiseReportPage")),
  "reports:bl-wise": lazy(() => import("../pages/reports/BLWiseReportPage")),
  "reports:bl-wise-report": lazy(() => import("../pages/reports/BLWiseReportPage")),
  "bl-wise:index": lazy(() => import("../pages/reports/BLWiseReportPage")),
  "reports:purchase-master-wise": lazy(() => import("../pages/reports/PurchaseMasterWiseReportPage")),
  "reports:purchase-master-wise-report": lazy(() => import("../pages/reports/PurchaseMasterWiseReportPage")),
  "purchase-master-wise:index": lazy(() => import("../pages/reports/PurchaseMasterWiseReportPage")),
  "reports:stock-report": lazy(() => import("../pages/reports/StockReportPage")),
  "reports:bill-report": lazy(() => import("../pages/reports/BillReportPage")),
  "reports:selling-report": lazy(() => import("../pages/reports/SellingReportPage")),
  "reports:lot-wise": lazy(() => import("../pages/reports/LotWiseReportPage")),
  "reports:lot-wise-report": lazy(() => import("../pages/reports/LotWiseReportPage")),
  "lot-wise:index": lazy(() => import("../pages/reports/LotWiseReportPage")),
  "purchase-master:index": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchase-master:list": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchase-master:read": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchase-master:create": lazy(() => import("../pages/purchaseMaster/PurchaseMasterFormPage")),
  "purchase-master:edit": lazy(() => import("../pages/purchaseMaster/PurchaseMasterFormPage")),
  "purchase-master:update": lazy(() => import("../pages/purchaseMaster/PurchaseMasterFormPage")),
  "purchasemaster:index": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchasemaster:list": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchasemaster:read": lazy(() => import("../pages/purchaseMaster/PurchaseMasterListPage")),
  "purchase-payment-master:index": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master:list": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master:create": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master:edit": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master:update": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "bl-management:purchase-payment-master": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master": lazy(() => import("../pages/purchasePayment/PurchasePaymentMasterPage")),
  "purchase-payment-master:payments": lazy(() => import("../pages/purchasePayment/PurchasePaymentDetailPage")),
  "sales-payment-master:index": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master:list": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master:create": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master:edit": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master:update": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "invoice-management:sales-payment-master": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master": lazy(() => import("../pages/salesPayment/SalesPaymentMasterPage")),
  "sales-payment-master:payments": lazy(() => import("../pages/salesPayment/SalesPaymentDetailPage")),
  "shipping-line:index": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "shipping-line:list": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "shipping-line:create": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "shipping-line:edit": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "master:shipping-line": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "settings-master:shipping-line": lazy(() => import("../pages/shippingLine/ShippingLineModulePage")),
  "customer-master:index": lazy(() => import("../pages/customer/CustomerListPage")),
  "customer-master:list": lazy(() => import("../pages/customer/CustomerListPage")),
  "customer-master:create": lazy(() => import("../pages/customer/CustomerFormPage")),
  "customer-master:edit": lazy(() => import("../pages/customer/CustomerFormPage")),
  "customer-master:update": lazy(() => import("../pages/customer/CustomerFormPage")),
  "settings-master:customer-master": lazy(() => import("../pages/customer/CustomerListPage")),
  "customer:index": lazy(() => import("../pages/customer/CustomerListPage")),
  "expense-category:expense-categories": lazy(() => import("../pages/expenseCategory/ExpenseCategoryModulePage")),
  "settings-master:expense-category": lazy(() => import("../pages/expenseCategory/ExpenseCategoryModulePage")),
  "expense-overhead": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadListPage")),
  "expense-overhead:index": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadListPage")),
  "expense-overhead:list": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadListPage")),
  "expense-overhead:create": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadFormPage")),
  "expense-overhead:edit": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadFormPage")),
  "expense-overhead:update": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadFormPage")),
  "settings-master:expense-overhead": lazy(() => import("../pages/expenseOverhead/ExpenseOverheadListPage")),
  "company:index": lazy(() => import("../pages/company/CompanyModulePage")),
  "company:list": lazy(() => import("../pages/company/CompanyModulePage")),
  "company:create": lazy(() => import("../pages/company/CompanyModulePage")),
  "company:edit": lazy(() => import("../pages/company/CompanyModulePage")),
  "company:update": lazy(() => import("../pages/company/CompanyModulePage")),
  "settings-master:company": lazy(() => import("../pages/company/CompanyModulePage")),
  "selling-master:index": lazy(() => import("../pages/sellingMaster/SellingMasterListPage")),
  "selling-master:list": lazy(() => import("../pages/sellingMaster/SellingMasterListPage")),
  "selling-master:create": lazy(() => import("../pages/sellingMaster/SellingMasterFormPage")),
  "selling-master:edit": lazy(() => import("../pages/sellingMaster/SellingMasterFormPage")),
  "selling-master:update": lazy(() => import("../pages/sellingMaster/SellingMasterFormPage")),
  "invoice-management:selling-master": lazy(() => import("../pages/sellingMaster/SellingMasterListPage")),
  "selling-master": lazy(() => import("../pages/sellingMaster/SellingMasterListPage")),
  // "role-menus": lazy(() => import("../pages/roleMenus/RoleMenuPage")),
};

function normalize(value = "") {
  return String(value)
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/[_\s]+/g, "-")
    .replace(/[^a-zA-Z0-9-]/g, "")
    .toLowerCase();
}

export function resolveMenuComponent(menu) {
  const controller = normalize(menu?.controllerName);
  const action = normalize(menu?.actionName) || "index";
  return (
    pageRegistry[`${controller}:${action}`] ||
    pageRegistry[controller] ||
    pageRegistry[`${controller}:index`]
  );
}
